/* ========================================================================= */
/* Routes */
/* ========================================================================= */
/** @type {import("$types/hapi/cms-methods").CmsRouteDefinition[]} */
let ROUTES;

/** @param {import("$types/hapi/cms-methods").CmsRouteDefinition[]} d */
export const setRoutes = (d) => {
    ROUTES = d;
};

export const getRoutes = () => {
    return ROUTES;
};


/**
 * Generates an URI based on the Taxonomy configuration in contentful.
 * @type {import("$types/utilities/routes").resolvePath}
 */
export const resolvePath = ({ slug, cfMetadata }) => {
    const route = getRoutes().find(r => cfMetadata?.concepts?.some(c => c?.id === r.conceptId));
    if (route) {
        return `/${route.uri}${slug ? `/${slug}`:''}`;
    }
    return '/';
};

